// Preview bundle entry. Loads in BOTH backoffice and the standalone configurator preview HTML route.
// MUST stay free of @umbraco-cms/backoffice imports — see memory
// feedback_plugin_bundles_no_umbraco_imports. The designer (workspace-context-aware property-editor)
// lives in a separate bundle that only loads in backoffice.

import './endmill-preview.js';
import { registerItemRenderer } from '@ixit/dof-core';
import { html } from 'lit';

registerItemRenderer({
    itemType: 'endmill',
    // The endmill's operations live INSIDE the blob, so the blob property itself is what an
    // unsaved grid can be recognised by — the same value EndmillSchemaBuilder parses.
    live: { elementTypeAlias: 'dofEndmill', configProperty: 'endmillConfig' },
    render: (item, state, onInputChange) => html`
        <ixit-endmill-preview
            .item=${item as any}
            .state=${state as any}
            .onInputChange=${onInputChange}
        ></ixit-endmill-preview>
    `,
});
